interface IAiLogoProps {
  size?: number;
  backgroundColor?: string;
  textColor?: string;
}

const AiLogo = ({
  size = 25,
  backgroundColor = '#1D1D78',
  textColor = 'white',
}: IAiLogoProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={size} height={size} rx="6" fill={backgroundColor} />
      <path
        d="M13.3672 17.8501L12.4656 15.5021H7.40047L6.4989 17.8501H4.31055L8.63808 7.03125H11.228L15.5474 17.8501H13.3672ZM8.03976 13.8411H11.8264L9.93306 8.91114L8.03976 13.8411Z"
        fill={textColor}
      />
      <path
        d="M16.6996 17.8501V7.03125H18.8305V17.8501H16.6996Z"
        fill={textColor}
      />
    </svg>
  );
};

export default AiLogo;
